import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import dayjs from "dayjs"
import http from "@services/httpService"
import { PagedResultDto } from "@services/dto/pagedResultDto"

class FeeTypeService {
  public async createOrUpdate(body: any) {
    if (body.birthDate) {
      body.birthDate = dayjs(body.birthDate).toISOString()
    }
    const res = await http.post("api/services/app/FeeType/CreateOrUpdate", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )

    return res.data.result
  }

  public async activateOrDeactivate(id: number, isActive) {
    const res = await http.post(
      "api/services/app/FeeType/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }

    const res = await http.get("api/services/app/FeeType/Get", {
      params: { id },
    })

    return res.data.result
  }

  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/FeeType/GetAll", { params })
    const result = res.data.result

    return result
  }

  public async getList(params: any): Promise<any[]> {
    const res = await http.get("api/services/app/FeeType/GetList", { params })
    const result = res.data.result

    return result
  }

  public async GetAll(params: any): Promise<any[]> {
    const res = await http.get("api/services/app/FeeVariable/GetAll", {
      params,
    })
    const result = res.data.result

    return result
  }
}

export default new FeeTypeService()
